import { render } from "./RecentActions.vue?vue&type=template&id=16ae65f8&scoped=true"
import script from "./RecentActions.vue?vue&type=script&lang=js"
export * from "./RecentActions.vue?vue&type=script&lang=js"

import "./RecentActions.vue?vue&type=style&index=0&id=16ae65f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ae65f8"]])

export default __exports__